// extracted by mini-css-extract-plugin
module.exports = {"icon":"IndeterminateCheckboxButton_icon__23-Tn"};